import { DamageEstimation } from './damage-estimation.class';
export class Damage {
    original_typology;
    modified_typology;
    main;
    isNewDamage;
    original_severity;
    modified_severity;
    uuid;
    area;
    confidence;
    description;
    partId;
    origin;
    original_deleted;
    modified_deleted;
    custom;
    extra;
    hasEstimation;
    from;
    vlcWarning = false;
    image_info = {};
    exists = false;
    estimation;
    others;
    maskFilename;
    missingFromExternalEstimation = false;
    constructor(main, others = [], isNewDamage = false, isMissingFromExternalEstimation = false) {
        this.main = main;
        this.isNewDamage = isNewDamage;
        this.missingFromExternalEstimation = isMissingFromExternalEstimation;
        const { damages, part: { description, id } } = main;
        const detail = damages.find(({ is_main }) => is_main) ?? damages[0];
        const { area, confidence, origin, origin_user: originUser, is_deleted: isDeleted, is_deleted_user: isDeletedUser, severity, severity_user: severityUser, typology, typology_user: typologyUser, is_extra: isExtra, from, mask_filename: maskFilename } = detail;
        this.maskFilename = maskFilename;
        this.uuid = detail.uuid;
        this.area = area;
        this.confidence = confidence;
        this.description = description;
        this.origin = originUser ?? origin;
        this.original_deleted = Boolean(isDeleted);
        this.modified_deleted = this.original_deleted;
        if (this.origin === 'additionalCost') {
            // This is because backend handles delete of additionals different
            this.modified_deleted = Boolean(isDeletedUser ?? isDeleted);
            this.from = 'agent';
        }
        this.original_severity = severity;
        this.modified_severity = severityUser;
        this.original_typology = typology;
        this.modified_typology = typologyUser;
        this.custom = detail.custom;
        this.extra = Boolean(isExtra);
        this.from = from ?? (!isExtra ? 'ai' : 'agent');
        this.partId = id;
        if (main.image_info?.image_uuid) {
            this.image_info.image_uuid = main.image_info?.image_uuid;
        }
        this.hasEstimation = Boolean(main.estimation);
        this.estimation = main.estimation
            ? new DamageEstimation(main.estimation)
            : {
                export: () => undefined,
                update: () => undefined,
                getPrice: () => undefined,
                paint: {},
                labour: {},
                assembly: {},
                updatePrice: () => undefined
            };
        this.others = others.map((other) => new Damage(other));
    }
    get deleted() {
        return this.modified_deleted ?? this.original_deleted;
    }
    set deleted(value) {
        this.modified_deleted = value;
    }
    get typology() {
        return this.modified_typology ?? this.original_typology;
    }
    set typology(value) {
        this.modified_typology = value;
    }
    get severity() {
        return this.modified_severity ?? this.original_severity;
    }
    set severity(value) {
        this.modified_severity = value;
    }
    setExists(value) {
        this.exists = value;
    }
    setDeleted(value) {
        this.deleted = value;
    }
    setOrigin(value) {
        this.origin = value;
    }
    updateEstimation(estimation) {
        this.estimation = estimation;
    }
    export() {
        const mainDetection = JSON.parse(JSON.stringify(this.main));
        const { damages, part } = mainDetection;
        const detail = damages.find(({ is_main }) => is_main) ?? damages[0];
        if (!this.original_typology && this.modified_typology) {
            this.original_typology = this.modified_typology;
        }
        if (!this.original_severity && this.modified_severity) {
            this.original_severity = this.modified_severity;
        }
        part.description = this.description;
        part.id = this.partId;
        detail.area = this.area;
        detail.severity = this.severity;
        detail.typology = this.typology;
        detail.custom = this.custom;
        detail.origin = this.origin;
        detail.from = this.from;
        detail.is_main = true;
        if (this.modified_deleted !== this.original_deleted) {
            detail.is_deleted_user = true;
        }
        mainDetection.estimation = this.estimation.export(this.from === 'ai', this.isNewDamage);
        mainDetection.image_info = { ...mainDetection.image_info, ...this.image_info };
        const otherDetection = this.others.map((other) => other.export().mainDetection);
        return { mainDetection, otherDetection };
    }
    clone() {
        const exportation = this.export();
        const damageClone = new Damage(exportation.mainDetection, exportation.otherDetection);
        const price = this.estimation.getPrice();
        if (price) {
            damageClone.estimation.updatePrice(price);
        }
        return damageClone;
    }
}
